module.exports = __webpack_public_path__ + "static/media/s2.a505896d.png";